module.exports = __webpack_public_path__ + "img/weixin.667fae37.jpg";